module.exports = __webpack_public_path__ + "img/右侧线条.f2adc3f1.png";